import React from 'react';
import { Chip } from '@mui/material';
import { useExpertPlan } from '@/hooks/useExpertPlan';

export const ProChip: React.FC = () => {
  const { subscription, loading } = useExpertPlan();

  if (loading || subscription?.planCode === 'pro_tier') return null;

  return (
    <Chip
      label="PRO"
      size="small"
      sx={{
        height: 16,
        fontSize: '0.6rem',
        fontWeight: 700,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        flexShrink: 0,
        '& .MuiChip-label': { px: 0.75 },
      }}
    />
  );
};
